import { inviteSentRoute, loginRoute, selectCompanyRoute } from '@feature/user/user-routes';

export const administrationRoute = 'administration';
export const bindingOfferRoute = 'binding-offer';
export const clientAdvisorRoute = 'client-advisor';
export const communicationRoute = 'communication';
export const dataroomRoute = 'data-room';
export const clientDataroomRoute = 'client/data-room';
export const clientsRoute = 'clients';
export const clientColleagueUsersRoute = 'colleagues';
export const companyContactsRoute = 'company-contacts';
export const clientDasboardRoute = 'dashboard';
export const clientBasketsRoute = 'baskets';
export const clientTransactionsRoute = 'transactions';
export const clientContractsRoute = 'contracts';
export const clientTemplatesRoute = 'client-templates';
export const basketsRoute = 'baskets';
export const basketEnvelopRouteName = 'sign-document';
export const envelopesRoute = 'envelopes/:envelope_uid/parties/:user_uid';
export const envelopesRouteExtension = ':envelope_uid/parties/:user_uid';
export const productCommissionRoute = 'product-commission';
export const bankingDetailsRoute = 'banking-details';
export const marketingRoute = 'marketing';
export const summaryRoute = 'summary';
export const indicativeOfferRoute = 'indicative-offer';
export const investorRoute = 'investor';
export const issuingProcessRoute = 'issuing-process';
export const issuingRoute = 'issuing';
export const clientIssuingRoute = 'client-issuings';
export const clientRoute = 'client';
export const partnerRoute = 'ready4impact';
export const productRoute = 'product';
export const profileRoute = 'profile';
export const qaRoute = 'qa';
export const questionsAndAnswersRoute = 'questions-and-answers';
export const userEntryRoute = 'user';
export const loginAbsoluteRoute = `${userEntryRoute}/${loginRoute}`;
export const inviteSentAbsoluteRoute = `${userEntryRoute}/${inviteSentRoute}`;
export const loginPartnerAbsoluteRoute = `${userEntryRoute}/${partnerRoute}/${loginRoute}`;
export const selectCompanyAbsoluteRoute = `${userEntryRoute}/${selectCompanyRoute}`;
export const selectPartnerCompanyAbsoluteRoute = `${userEntryRoute}/${partnerRoute}/${selectCompanyRoute}`;
export const superUserRoute = 'superuser';
export const pendingAreaRoute = 'pending-area';
export const contractsRoute = 'contracts';
export const reportSuspiciousActivityRoute = 'report-suspicious-activity';
export const fundDDQRunsRoute = 'fund-ddq-runs';
export const ddqInviteesRoute = 'invitees';

export const routeParams: Record<string, string> = {
  companyId: 'companyId',
  dataRoomNodeId: 'dataRoomNodeId',
  issuingId: 'issuingId',
  clientIssuingId: 'clientIssuingId',
  productId: 'productId',
  topicId: 'topicId',
  userId: 'userId',
  clientId: 'clientId',
  basketId: 'basketId',
};
